export default __webpack_public_path__ + "static/media/puertorico_flag.2d4aeb33.svg";